import { INVALID, PENDING, UNKNOWN, VALID } from '../PropertyValidationStatus';
export function isSaveableValidationStatus(validationStatus) {
  return validationStatus === VALID || validationStatus === UNKNOWN;
}
export function isInvalidValidationStatus(validationStatus) {
  return validationStatus === INVALID;
}
export function isPendingValidationStatus(validationStatus) {
  return validationStatus === PENDING;
}